import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

export function useQueryParams(): URLSearchParams {
  const location = useLocation();
  return new URLSearchParams(location.search);
}

export function useQueryParamsAsKeyValuePair(): Record<string, any> | null {
  const queryString = useLocation().search;
  const getQueryObject = (str: string) =>
    str
      .substr(1)
      .split('&')
      .reduce((acc, query) => {
        const indexOfEqualSign = query.indexOf('=');
        const key = indexOfEqualSign > -1 ? query.substr(0, indexOfEqualSign) : query;
        const value = indexOfEqualSign > -1 ? query.substr(indexOfEqualSign + 1) : '';
        let finalValue: string | boolean = decodeURIComponent(value);
        if (finalValue === 'true') finalValue = true;
        else if (finalValue === 'false') finalValue = false;

        if (finalValue !== '') {
          acc[key] = finalValue;
        }
        return acc;
      }, {} as Record<string, any>);

  const [queryObject, setQuery] = useState(getQueryObject(queryString));

  useEffect(() => {
    setQuery(() => getQueryObject(queryString));
  }, [queryString]);

  return queryObject;
}
